import React from "react"
import DateTime from "../Utility/Method/DateTime"
const LoginRegisterContext = React.createContext({
    info: {
        PhoneNumber: '',
        VerifiedID: '',
        FirstName: '',
        LastName: '',
        Code: '',
        phoneCode: '+98',
        timeZone: DateTime.timeZone()
    },
    setInfo: () => { }
})
export default LoginRegisterContext